import React from "react"

const shimmer =
	"animate-pulse bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded-md"

const Line = ({ width = "w-full", className = "" }) => (
	<div className={`h-4 ${width} ${shimmer} ${className}`} />
)

const Card = () => (
	<div className="bg-white shadow-md rounded-lg p-1 flex flex-col justify-between">
		<div className="flex items-start p-4">
			<div className={`h-10 w-10 mr-4 ${shimmer}`} />
			<div className="flex-1 text-left">
				<div className={`h-3 w-24 ${shimmer} mb-3`} />
				<div className={`h-9 w-16 ${shimmer}`} />
			</div>
		</div>
		<div className="py-3 flex justify-center bg-customBg">
			<div className={`h-3 w-20 ${shimmer}`} />
		</div>
	</div>
)

export const ChartSkeleton = () => (
	<div className="my-6 p-6 bg-white shadow-md rounded-lg">
		<div className={`h-6 w-48 ${shimmer} mb-4`} />
		<div className={`h-64 w-full ${shimmer}`} />
	</div>
)

const DailyHuddleSkeleton = ({ sidebarOpen }) => (
	<div className={`${sidebarOpen ? "pl-64" : "pl-8"} w-screen`}>
		<div className="my-5 flex h-16 items-center justify-between bg-white px-4 sm:px-6 lg:px-8">
			<div className={`h-9 w-64 ${shimmer}`} />
		</div>

		<main className="py-10">
			<div className="px-4 sm:px-6 lg:px-8 text-left">
				<Line width="w-32" className="mb-4" />
				<Line className="mb-2" />
				<Line width="w-11/12" className="mb-2" />
				<Line width="w-3/4" className="mb-6" />

				<Line width="w-2/3" className="mb-6" />

				<hr className="my-4 border-t border-gray-200" />

				<div className="space-y-3 mb-8">
					<Line width="w-5/6" />
					<Line width="w-4/6" />
					<Line width="w-4/6" />
					<Line width="w-3/6" />
				</div>

				<div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
					<Card />
					<Card />
					<Card />
				</div>

				<ChartSkeleton />
			</div>
		</main>
	</div>
)

export default DailyHuddleSkeleton
